import { HttpLink as BaseHttpLink } from '@apollo/client';

export const HttpLink = new BaseHttpLink({
  uri: process.env.NEXT_PUBLIC_API_GRAPHQL_ENDPOINT,
});
